import React from "react";
import "./Socials.scss";

const TwitterLogo = () => {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 75 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_41_13)">
        <path
          d="M69.614 69.1446L44.4839 32.5161L41.6419 28.3735L23.6649 2.17068L22.1758 0H0.0859375L5.47382 7.85542L29.375 42.6988L32.2171 46.8373L51.4229 74.8333L52.912 77.002H75.0019L69.614 69.1466V69.1446ZM55.5379 71.9859L35.5855 42.9016L32.7435 38.761L9.59078 5.01406H19.5499L38.2734 32.3072L41.1155 36.4478L65.497 71.9879H55.5379V71.9859Z"
          fill="white"
        />
        <path
          d="M32.7436 38.7607L35.5836 42.9013L32.2172 46.835L6.37259 76.9997H0L29.3751 42.6965L32.7436 38.7607Z"
          fill="white"
        />
        <path
          d="M72.342 0L44.4819 32.5161L41.1155 36.4478L38.2734 32.3072L41.6419 28.3735L60.5135 6.33735L65.9674 0H72.342Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_41_13">
          <rect width="75" height="77" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TwitterLogo;
